import {
  SET_INVOICES_FETCH_LOADING,
  SET_INVOICES_DATA,
  SET_INVOICES_FETCH_DATA_ERROR,
  SET_INVOICES_FILTERS,
  SET_INVOICES_FETCH_METRICS_LOADING,
  SET_INVOICES_METRICS_DATA,
  SET_INVOICES_FETCH_METRICS_DATA_ERROR,
  SET_INVOICES_PAGINATION,
} from 'src/common/actions/constants';
import moment from 'moment';

const defaultRange = [moment().subtract(6, 'days'), moment()];
const defaultTimeFilters = [{
  columnName: 'created_at',
  fromDateString: defaultRange[0].format('YYYY-MM-DD'),
  toDateString: defaultRange[1].format('YYYY-MM-DD'),
}];
const defaultState = {
  isLoading: false,
  invoicesData: {},
  filters: {
    timeFilters: defaultTimeFilters,
    bucket: 'consignment_invoice_all',
    search: {
      searchBy: 'consignmentReferenceNumber',
      searchValue: '',
    },
  },
  pagination: {
    pageNumber: 1,
    resultPerPage: 50,
    isNextPresent: false,
  },
  metricsData: {},
};

export default (state = defaultState, action) => {
  const { data } = action;
  switch (action.type) {
    case SET_INVOICES_FETCH_LOADING: {
      return {
        ...state,
        isLoading: data,
      };
    }

    case SET_INVOICES_DATA: {
      return {
        ...state,
        invoicesData: data,
      };
    }

    case SET_INVOICES_FETCH_DATA_ERROR: {
      return {
        ...state,
        invoicesData: { error: data },
      };
    }

    case SET_INVOICES_FILTERS: {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...data,
        },
      };
    }

    case SET_INVOICES_FETCH_METRICS_LOADING: {
      return {
        ...state,
        metricsData: {
          ...state.metricsData,
          isLoading: data,
        },
      };
    }

    case SET_INVOICES_METRICS_DATA: {
      return {
        ...state,
        metricsData: {
          ...state.metricsData,
          data: data?.[0] || {},
        },
      };
    }

    case SET_INVOICES_FETCH_METRICS_DATA_ERROR: {
      return {
        ...state,
        metricsData: {
          error: data,
        },
      };
    }

    case SET_INVOICES_PAGINATION: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...data,
        },
      };
    }

    default:
      return state;
  }
};
